import { firestore as db } from "../../firebaseConfig";
import { collection, query, where, getDocs, doc, onSnapshot, setDoc, getDoc, startAfter, startAt, limit, orderBy, endAt, getCountFromServer, Timestamp } from "firebase/firestore";

export const generateCode=()=>(+new Date * Math.random()).toString(36).substring(0,8)

export const getStoresAllAnalysis=async(list)=>{ //minutes,products,amount
    try {
        
        let obj = {}
        for(let merchant of list){
            const docRef = doc(db, `stores/${merchant}/analysis`,"allAnalysis")
            const docSnap = await getDoc(docRef);//collection(db, `stores/${merchant}/analysis/allAnalysis`)
            if(docSnap.exists()){
                obj[merchant]={ 
                    minutes: docSnap.data().totalMinutes,
                    quantity: docSnap.data().totalQuantity,
                    sales: docSnap.data().totalAmount
                };
            }else{
                obj[merchant] ={
                    minutes: 0,
                    quantity: 0,
                    sales: 0
                }; 
            }
        }
        let minutes = []
        let sales=[]
        let quantity = []
        for (let merch of list) {
            minutes.push(obj[merch].minutes)
            quantity.push(obj[merch].quantity)
            sales.push(obj[merch].sales)
        }
        return { data: {sales,minutes,quantity}, error: false }
    } catch (e) {
        // console.log(e.message);
        return {data:null,error:true}
    }
}

export const getStoresInitData=async(initial=true,start="")=>{
    try {
        const col = query(collection(db, "stores"), orderBy('name'))
        const snapshot = await getCountFromServer(col);
        // console.log('count: ', snapshot.data().count);
        const count = snapshot.data().count
        // console.log(start,"start")
        const q =  query(collection(db, "stores"),orderBy('name'), startAfter(start),limit(3) );
        let list = []
        let ids=[]
        const querySnapshot=await getDocs(q)
        querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            ids.push(doc.id)
            list.push({ ...doc.data(), id: doc.id })
        });
        return { data: list,ids,count, error: false }
    } catch (e) {
        // console.log(e.message);
        return { data: null, error: true }
    }
    
}
export const getNewSubsTM = async(stores ,startafter="")=>{
    try{
    let obj = {};
    for(let store of stores){
        obj[store]=[]
        // list of sum of subs on specific month and total money ;
        const current=new Date()
        const end=current.toISOString()
        const start = new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0).toISOString();
        // const 
        const q = query(collection(db, `stores/${store}/subscription`),
            where('created_at', ">=", start), 
            // where('created_at', ">=", endDate),
            orderBy("created_at"),
            // startAfter(startafter)
            );
        const querySnapshot = await getDocs(q);
        if(querySnapshot.empty){
            obj[store]=[{money:0,minutes:0}]
        }else{
            querySnapshot.forEach((doc) => {
            // doc.data() is never undefined for query doc snapshots
            // console.log(doc.id, " => ", doc.data());
            const n = new Set(doc.data().dateSubscription).size
            obj[store].push({ money: doc.data().plan.pricePlan * n, minutes: doc.data().plan.minutes*n, id: doc.id })
        });

        }
    }
    // console.log(obj,"obj")
    let storesData={}
    for(let item in obj){
        let minutes=0
        let money=0
        obj[item].map(i=>{
            minutes+=i.minutes
            money+=i.money
            return
        })
        // console.log(minutes,money,"min,money")
        storesData[item]={minutes,money}
    }
    // console.log(storesData,"dddddddddddd")
        let minutes = []
        let money = []
        for (let merch of stores) {
            minutes.push(storesData[merch].minutes)
            money.push(storesData[merch].money)
        }
        // console.log("get ntm data",minutes,money)
        return { data: { money, minutes }, error: false }
    } catch (e) {
        return { data: null, error: true }
    }
}
export const getCancelledSubs = async (stores, period = "tm") => {
    try {
        const current = new Date();
        const month = current.getMonth()
        let start;
        let end;
        if (period == "tm") {
            end = current;
            start = new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0);
        } else {
            start = new Date(current.getFullYear(), month - 1, 1, 0, 0, 0);
            end = new Date(current.getFullYear(), month, 0, 23, 59, 59);
        }

        // const startOfDay = Timestamp.fromDate(data)
        // startOfDay.setHours(0, 0, 0, 0);
        // console.log(Timestamp.fromDate(start), Timestamp.fromDate(end))
        let cancelledList=[]
        for(let store of stores){
            const q = query(collection(db, `stores/${store}/subscription`),
            where("dateCanceled", ">=", Timestamp.fromDate(start)),
            where("dateCanceled", "<=", Timestamp.fromDate(end)),
            orderBy("dateCanceled"),
            // startAfter(startafter)
        );
        const snapshots = await getDocs(q)
        let count = 0;
        const list = []
        snapshots.forEach(doc => {
            list.push({name:store,...doc.data()})
            count++
        })
        // list.push(count)
        cancelledList.push(count)
        }
        
        // console.log(list, "all", "count", count)
        return {data:cancelledList,error:false}
    } catch (e) {
        // console.log(e.message, "error on getSubsTM")
        return { error: true, data: null }
    }
}
export const getAllSubsTM = async (stores, startDate, endDate, startafter="")=>{
    try {
        const list=[]
        let obj={}
        for (let store of stores) {
            obj[store] = []
            // list of sum of subs on specific month and total money ;
            // const current = new Date();
            // const thisMonth = new Date(current.getFullYear(), current.getMonth(), 1, 0, 0, 0)
            // const end = current.toISOString()
            // const start = thisMonth.toISOString();
            // console.log("here",thisMonth)
            let newMonth = startDate.getMonth()+1 
            // console.log("month",month)
            newMonth = (newMonth < 10) ? '0' + newMonth.toString() : newMonth.toString();
            const q = query(collection(db, `stores/${store}/subscription`),
                where("subsDateStr","array-contains",`${startDate.getFullYear()}-${newMonth}`),
                // startAfter(startafter)
                );
            const querySnapshot = await getDocs(q);
            if (querySnapshot.empty) {
                obj[store] = [{ money: 0, minutes: 0 }]
            } else {
                // console.log(startDate,endDate)
                querySnapshot.forEach((doc) => {

                    
                    obj[store].push({ money: doc.data().plan.pricePlan , minutes: doc.data().plan.minutes , id: doc.id })
                    // if (doc.data().statusSubscription.toLowerCase()==="active"||
                    //     (doc.data().dateCanceled?.toDate() - startDate >= 0 && doc.data().dateCanceled?.toDate() - endDate <= 0) ){
                    //     const dates = new Set(doc.data().dateSubscription)
                    //     let n=0
                    //     if(dates.size>0){
                    //         for(let item of dates){
                    //             // console.log(item.toDate().toISOString(), doc.data().dateCanceled?.toDate() - startDate >= 0 || doc.data().dateCanceled?.toDate() - endDate <= 0,"isafter");
                    //             if (item.toDate() - startDate >= 0 && item.toDate() - endDate <= 0) n++
                    //     }
                    //         obj[store].push({ money: doc.data().plan.pricePlan * n, minutes: doc.data().plan.minutes * n, id: doc.id })
                    //     }
                        
                    // }
                })
            }
        }
        let storesData = {}
        for (let item in obj) {
            let minutes = 0
            let money = 0
            obj[item].map(i => {
                minutes += i.minutes
                money += i.money
                return
            })
            // console.log(minutes,money,"min,money")
            storesData[item] = { minutes, money }
        }
        // console.log(storesData,"dddddddddddd")
        let minutes = []
        let money=[]
        for (let merch of stores) {
            minutes.push(storesData[merch].minutes)
            money.push(storesData[merch].money)
        }
        // console.log("finalData", money,minutes)
        return {data:{money,minutes},error:false}
    } catch (e) {
        return {data:null,error:true}
    }
}
// getAllSubsTM(["expertminute","ExpertMinute-Dev"])